export default __webpack_public_path__ + "static/media/authors5.b14a6a42.jpg";